module.exports = __webpack_public_path__ + "img/logo_vertical.1d73f36b.svg";